import type { ExtraSection } from '@/types/extraSection'
import { DEFAULT_EXTRA_SECTION } from '@/types/extraSection'

export function normalizeExtraSection(section: Record<string, unknown>): ExtraSection {
  return {
    ...DEFAULT_EXTRA_SECTION,
    ...section,
    id: Number(section.id) || Date.now(),
    collapsed: section.collapsed !== undefined ? Boolean(section.collapsed) : true,
    is_active: section.is_active !== undefined ? Boolean(section.is_active) : true,
    hidden_on_mobile:
      section.hidden_on_mobile !== undefined ? Boolean(section.hidden_on_mobile) : false,
    position: (section.position as string) || 'after_store',
    layout: (section.layout as string) || 'page_builder',
    background_color: (section.background_color as string) || '#ffffff',
    background_type: (section.background_type as ExtraSection['background_type']) || 'color',
    gradient_color1: (section.gradient_color1 as string) || '#3b82f6',
    gradient_color2: (section.gradient_color2 as string) || '#2563eb',
    gradient_angle: Number(section.gradient_angle) || 135,
    gradient_type: (section.gradient_type as ExtraSection['gradient_type']) || 'linear',
    gradient_color1_location: Number(section.gradient_color1_location ?? 0),
    gradient_color2_location: Number(section.gradient_color2_location ?? 100),
    pattern_type: (section.pattern_type as ExtraSection['pattern_type']) || 'animated-balls',
    pattern_color: (section.pattern_color as string) || '#006D5B',
    pattern_color2: (section.pattern_color2 as string) || '#FF6F61',
    title_color: (section.title_color as string) || '#212529',
    title_size: (section.title_size as string) || 'h2',
    section_size: (section.section_size as string) || 'medium',
    box_shadow: section.box_shadow !== undefined ? Boolean(section.box_shadow) : true,
    backdrop_blur: section.backdrop_blur !== undefined ? Boolean(section.backdrop_blur) : true,
    widgets: Array.isArray(section.widgets) ? section.widgets : [],
    gallery: Array.isArray(section.gallery) ? section.gallery : [],
  } as ExtraSection
}

export function normalizeExtraSections(raw: unknown): ExtraSection[] {
  let sections = raw

  if (typeof sections === 'string') {
    try {
      sections = JSON.parse(sections)
    } catch {
      return []
    }
  }

  if (!Array.isArray(sections)) return []

  return sections.map((s) => normalizeExtraSection(s as Record<string, unknown>))
}

/** Strip admin-only UI fields before persisting to the database */
export function stripExtraSectionForSave(section: ExtraSection): ExtraSection {
  const { collapsed, ...rest } = section
  void collapsed
  return rest
}

export function stripExtraSectionsForSave(sections: ExtraSection[]): ExtraSection[] {
  return sections.map(stripExtraSectionForSave)
}
